import Web3 from "web3";
import { getChainDataByChainId } from "../utils";
import BigNumber from "bignumber.js";
import { getBalanceNumber } from "../utils/formatBalance";

const web3 = new Web3(Web3.givenProvider);

export const getWeb3ForChainId = async (chainId) => {
  let chainData = getChainDataByChainId(chainId)
  if (!Web3.givenProvider) {
    return new Web3(chainData.wssRPC || chainData.httpRPC)
  }
  let localChainId = await getChainId()
  if (localChainId === chainId) {
    return web3
  } else {
    return new Web3(chainData.wssRPC || chainData.httpRPC)
  }
}


let rewardDecimal;
let poolTokenDecimal;

export let theme;

export const dynamicTheme = async (Theme) => {
  theme = Theme;
  console.log("themeInchain", theme);
};

export const setRewardDecimalLocally = (rewardD, poolTokenD) => {
  rewardDecimal = rewardD;
  poolTokenDecimal = poolTokenD;
};

export const reqAccountAndSignature = async (msg) => {
  let accounts;
  if (window.ethereum) {
    accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
  } else {
    accounts = await web3.eth.requestAccounts();
  }
  return [accounts[0]];
};

export const getChainId = async () => {
  const chainId = await web3.eth.net.getId();
  return chainId;
};

export const getAccount = async () => {
  try {
    const account = await web3.eth.getAccounts();
    return account[0];
  } catch (error) {
    return "";
  }
};

export const getBalance = async (account) => {
  const balance = await web3.eth.getBalance(account);
  return getBalanceNumber(balance)
};

export const balanceOfTVL = async (corePoolAddress, poolTokenContract) => {
  try {
    const TVLBalance = await poolTokenContract?.methods
      ?.balanceOf(corePoolAddress)
      .call();
    return getBalanceNumber(TVLBalance, poolTokenDecimal);
  } catch (e) {
    console.log(e)
  }
};

export const totalStakeValue = async (poolFactoryContract) => {
  try {
    const totalStake = await poolFactoryContract?.methods
      ?.totalStakedCount()
      .call();
    return totalStake;
  } catch (e) {
    console.log(e)
    return "";
  }
};

export const poolDetailFromNetwork = async (
  corePoolContract,
  poolFactoryContract,
  poolTokenAddress
) => {
  try {
    const endBlock = await poolFactoryContract?.methods?.endBlock().call();
    const tokenPerBlock = await poolFactoryContract?.methods
      ?.rewardTokenPerBlock()
      .call();
    const totalWeight = await poolFactoryContract?.methods
      ?.totalWeight()
      .call();
    // const rewardToken = await poolFactoryContract?.methods
    //   ?.rewardToken()
    //   .call();
    const data = await poolFactoryContract?.methods
      ?.getPoolData(poolTokenAddress)
      ?.call();

    const rewardTokenPerBlock =
      tokenPerBlock * (parseFloat(data[2]) / parseFloat(totalWeight));
    const startBlock = await corePoolContract?.methods?.startBlock().call();
    const currentBlockNO = await corePoolContract?.methods
      ?.blockNumber()
      .call();
    return { endBlock, startBlock, rewardTokenPerBlock, currentBlockNO };
  } catch (e) {
    console.log(e)
    return "";
  }
};

export const eligibleUnstake = async (corePoolContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    const eligibleUnstake = await corePoolContract?.methods
      ?.eligibleUnstake(address)
      .call();

    return eligibleUnstake;
  } catch (e) {
    return "";
  }
};

export const stake = async (amount, timelaps, isStaked, corePoolContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    await corePoolContract?.methods?.stake(amount, timelaps).send({
      from: address,
    });
    isStaked(true);
    return true;
  } catch (e) {
    console.log(e)
    isStaked(false);
    return false;
  }
};

export const UnStake = async (amount, isUnStaked, corePoolContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    await corePoolContract?.methods?.unstakeAll(amount).send({
      from: address,
    });
    isUnStaked(true);
    return true;
  } catch (e) {
    isUnStaked(false);
    return false;
  }
};

export const Claim = async (amount, isClaimed, corePoolContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    await corePoolContract?.methods?.processRewards(amount).send({
      from: address,
    });
    isClaimed(true);
    return true;
  } catch (e) {
    isClaimed(false);
    return false;
  }
};

export const earnedReward = async (corePoolContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    const Reward = await corePoolContract?.methods
      ?.earnedReward(address)
      .call();
    return getBalanceNumber(Reward, rewardDecimal)
  } catch (e) {
    return "";
  }
};

export const UserInfo = async (corePoolContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    const userDetails = await corePoolContract?.methods?.users(address).call();
    return userDetails;
  } catch (e) {
    return 0;
  }
};

export const RewardDistributed = async (poolFactoryContract) => {
  try {
    const totalReward = await poolFactoryContract?.methods
      ?.totalRewardSupply()
      .call();
    console.log("poolFactoryAddress", poolFactoryContract);
    return getBalanceNumber(totalReward, poolTokenDecimal);
  } catch (e) {
    return "";
  }
};

export const RewardBalanceOf = async (rewardContract, poolFactoryAddress) => {
  try {
    const totalBalance = await rewardContract?.methods
      ?.balanceOf(poolFactoryAddress)
      .call();
    return getBalanceNumber(totalBalance, poolTokenDecimal);
  } catch (error) {
    return "";
  }
};

export const Approve = async (corePoolAddress, poolTokenContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    const UINT256_MAX =
      "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff";
    const approveResponse = await poolTokenContract?.methods
      ?.approve(corePoolAddress, UINT256_MAX)
      ?.send({ from: address });
    return getBalanceNumber(approveResponse, poolTokenDecimal);
  } catch (error) {
    return "";
  }
};

export const Allowance = async (corePoolAddress, poolTokenContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    const allowance = await poolTokenContract?.methods
      ?.allowance(address, corePoolAddress)
      ?.call();
    return allowance;
  } catch (error) {
    return "";
  }
};

export const getBalanceOf = async (poolTokenContract) => {
  try {
    const address = await getAccount();
    if (address === undefined || address === "NaN" || address === "") {
      return 0;
    }
    const allowance = await poolTokenContract.methods.balanceOf(address).call();
    return allowance;
  } catch (error) {
    return "";
  }
};

// export const APY = async (
//   corePoolContract,
//   corePoolAddress,
//   poolTokenContract,
//   poolFactoryContract
// ) => {
//   const staked_token_price = 0.05;
//   const blocks_per_day = 4 * 60 * 24;
//   const Temp1 = await poolDetailFromNetwork(
//     corePoolContract,
//     poolFactoryContract
//   );
//   const REWARD_per_block = (
//     Temp1?.rewardTokenPerBlock / Math.pow(10, rewardDecimal)
//   ).toFixed(2);

//   const REWARD_Token_Price = 0.05;
//   const REWARD_Per_Day = REWARD_per_block * blocks_per_day;
//   const Temp2 = await balanceOfTVL(corePoolAddress, poolTokenContract);

//   const Total_Staked = Temp2 * staked_token_price;

//   const Apy =
//     100 * ((REWARD_Token_Price * REWARD_Per_Day) / Total_Staked) * 365;

//   return Apy.toFixed(2);
// };

export const Symbols = async (rewardContract, poolTokenContract) => {
  try {
    const rewardTknSymbol = await rewardContract?.methods?.symbol().call();
    const poolTknSymbol = await poolTokenContract?.methods?.symbol().call();
    return { rewardTknSymbol, poolTknSymbol };
  } catch (e) {
    return 0;
  }
};

export const calculateVesting = async (
  corePoolContract,
  poolFactoryContract
) => {
  try {
    const vestingTime = await poolFactoryContract?.methods
      ?.vestingWindow()
      .call();
    const Userinfo = await UserInfo(corePoolContract);
    const rT =
      Math.floor(Date.now() / 1000) - Userinfo.userLastRewardDistribution;
    const totaltime = rT + parseInt(Userinfo.remainderTime);
    const quotient = totaltime / vestingTime;
    const remainingTime = vestingTime - rT - Userinfo.remainderTime;
    return { quotient, remainingTime };
  } catch (e) {
    return 0;
  }
};

export const getDepositInfo = async (corePoolContract) => {
  try {
    const address = await getAccount();
    if (address && corePoolContract) {
      const depositId = await corePoolContract?.methods
        ?.getDepositsLength(address)
        .call();
      console.log("hello", corePoolContract)
      const depositDetails = await corePoolContract?.methods
        ?.getDeposit(address, parseInt(depositId) - 1)
        .call();
      console.log(depositDetails)
      const lockFrom = depositDetails[2];
      const lockUntil = depositDetails[3];
      return { lockFrom, lockUntil };
    }
    return 0;
  } catch (e) {
    console.log(e)
    return 0;
  }
};

export const yourWeightage = async (corePoolContract) => {
  try {
    const getDeposit = await getDepositInfo(corePoolContract);
    const lockDifference = getDeposit?.lockUntil - getDeposit?.lockFrom;
    const lockInWeek = lockDifference / 604800;
    if (lockInWeek >= 1) {
      const weightage = parseFloat(lockInWeek / 52 + 1).toFixed(2);
      return weightage;
    }
    return 1.02;
  } catch (e) {
    return 0;
  }
};

export const lockEnd = async (corePoolContract) => {
  try {
    const getDeposit = await getDepositInfo(corePoolContract);
    const lockDifference =
      getDeposit?.lockUntil - Math.floor(Date.now() / 1000);
    if (lockDifference > 0) {
      return lockDifference;
    } else {
      return 0;
    }
  } catch (e) {
    return 0;
  }
};

export const calculateAPY = async (
  chainId,
  rewardPerBlock,
  balanceOfTVL
) => {
  //TODO: change based on requirement
  const staked_token_price = 0.05;
  const REWARD_Token_Price = 0.05;

  let chainData = getChainDataByChainId(chainId)
  const blocks_per_day = (60 * 60 * 24) / chainData?.blockTime

  const REWARD_Per_Day = getBalanceNumber(rewardPerBlock, rewardDecimal, 18) * blocks_per_day;
  const Total_Staked = balanceOfTVL * staked_token_price;

  const Apy =
    100 * ((REWARD_Token_Price * REWARD_Per_Day) / Total_Staked) * 365;

  return Apy.toFixed(2);
}

// export const getActionBasedData = async (
//   corePoolContract,
//   corePoolAddress,
//   poolFactoryContract,
//   poolFactoryAddress,
//   rewardContract,
//   poolTokenContract,
//   chainId,
//   rewardPerBlock
// ) => {
//   try {
//     // const balanceOfTvl = await balanceOfTVL(corePoolAddress, poolTokenContract);
//     // const totalStakevalue = await totalStakeValue(poolFactoryContract);
//     // const Userinfo = await UserInfo(corePoolContract);
//     // const reward = await earnedReward(corePoolContract);

//     //na
//     const rewardDistributed = await RewardDistributed(poolFactoryContract);
//     const rewardBalanceOf = await RewardBalanceOf(
//       rewardContract,
//       poolFactoryAddress
//     );
//     const balanceOf = await getBalanceOf(poolTokenContract);
//     const Eligibleunstake = await eligibleUnstake(corePoolContract);

//     // const Apy = await calculateAPY(
//     //   chainId,
//     //   rewardPerBlock,
//     //   balanceOfTvl
//     // );

//     const tokenBalance = getBalanceNumber(balanceOf, poolTokenDecimal);
//     const RewardDiff = rewardDistributed - rewardBalanceOf;
//     // const totalStake = Userinfo?.tokenAmount && getBalanceNumber(Userinfo?.tokenAmount, poolTokenDecimal);
//     const EligibleunStake = getBalanceNumber(Eligibleunstake, poolTokenDecimal);

//     return {
//       rewardDistributed,
//       rewardBalanceOf,
//     };

//   } catch (error) {
//     console.log(error)
//   }
// }

export const getFirstLoadData = async (
  corePoolContract,
  corePoolAddress,
  poolFactoryContract,
  poolTokenContract,
  chainId,
  rewardPerBlock
) => {
  try {
    const balanceOfTvl = await balanceOfTVL(corePoolAddress, poolTokenContract);
    const totalStakevalue = await totalStakeValue(poolFactoryContract);
    const Userinfo = await UserInfo(corePoolContract);
    const totalStake = Userinfo?.tokenAmount && getBalanceNumber(Userinfo?.tokenAmount, poolTokenDecimal);
    const reward = await earnedReward(corePoolContract);
    const Apy = await calculateAPY(
      chainId,
      rewardPerBlock,
      balanceOfTvl
    );

    return {
      Apy,
      balanceOfTvl,
      totalStakevalue,
      totalStake,
      reward
    }
  } catch (error) {
    console.log(error)
  }
}

export const getSecondLoadData = async (
  corePoolContract,
  poolFactoryContract,
  poolFactoryAddress,
  rewardContract,
  poolTokenContract,
) => {
  const rewardDistributed = await RewardDistributed(poolFactoryContract);
  const rewardBalanceOf = await RewardBalanceOf(
    rewardContract,
    poolFactoryAddress
  );
  const balanceOf = await getBalanceOf(poolTokenContract);
  const EligibleunStake = await eligibleUnstake(corePoolContract);

  return {
    tokenBalance: getBalanceNumber(balanceOf, poolTokenDecimal),
    EligibleunStake: getBalanceNumber(EligibleunStake, poolTokenDecimal),
    RewardDiff: rewardDistributed - rewardBalanceOf,
    rewardDistributed,
    rewardBalanceOf,
  }
}

export const realTimeData = async (
  corePoolContract,
  corePoolAddress,
  poolFactoryContract,
  poolFactoryAddress,
  rewardContract,
  poolTokenContract
) => {
  try {
    const balanceOfTvl = await balanceOfTVL(corePoolAddress, poolTokenContract);
    const totalStakevalue = await totalStakeValue(poolFactoryContract);
    const Userinfo = await UserInfo(corePoolContract);
    const rewardDistributed = await RewardDistributed(poolFactoryContract);
    const rewardBalanceOf = await RewardBalanceOf(
      rewardContract,
      poolFactoryAddress
    );
    const balanceOf = await getBalanceOf(poolTokenContract);
    const Eligibleunstake = await eligibleUnstake(corePoolContract);
    const rewarD = await earnedReward(corePoolContract);
    // const Apy = await APY(
    //   corePoolContract,
    //   corePoolAddress,
    //   poolTokenContract,
    //   poolFactoryContract
    // );

    const tokenBalance = getBalanceNumber(balanceOf, poolTokenDecimal);
    const RewardDiff = rewardDistributed - rewardBalanceOf;
    const totalStake = Userinfo?.tokenAmount && getBalanceNumber(UserInfo?.tokenAmount, poolTokenDecimal);
    const reward = getBalanceNumber(rewarD, rewardDecimal);
    const EligibleunStake = getBalanceNumber(Eligibleunstake, poolTokenDecimal);

    return {
      balanceOfTvl,
      totalStakevalue,
      totalStake,
      rewardDistributed,
      rewardBalanceOf,
      RewardDiff,
      tokenBalance,
      EligibleunStake,
      reward,
      // Apy,
    };
  } catch (e) {
    return "";
  }
};

export const isConnected = async (web3) => {
  const accounts = await web3.eth.getAccounts();
  return !!accounts.length;
};

export const hexToNumber = (hex) => web3.utils.hexToNumber(hex);

// export const parseBalance = (num) =>
//   parseFloat((num / Math.pow(10, poolTokenDecimal)).toFixed(4));
